/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import L from "../Lang"
import BaseCom from "../BaseCom";
import Card from "../Card";
import Alert from "../Alert";
import Wound2 from "../Wound2";
import Globals from "../../shared/Globals";
import { Link } from "react-router-dom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class OrderWounds extends BaseCom {

    render() {
        const visits = [];
        const list = this.props.item.wounds.forEach(i => {
            let visit = visits.find(x => x.visitScheduleDate === i.visitScheduleDate);
            if(!visit) {
                visit = { id: i.visitID, visitScheduleDate: i.visitScheduleDate, wounds: [] };
                visits.push(visit);
            }

            visit.wounds.push(i);
            return i.visitScheduleDate;
        });
        return (
            <>
                {this.props.item.wounds && <>
                    {this.props.item.wounds.length === 0 ? <Alert><L>There are no wounds in record.</L></Alert> : <div>
                        <p><i><L>Sorted by schedule date, most recent ones first.</L></i></p>
                        {visits.map((visit,vidx) => <Card key={vidx} title={<><L>Wounds from</L><Link to={`/visit/view/${visit.id}`}>{Globals.toMDYLocalDateString(visit.visitScheduleDate)}</Link></>}
                            headerButtons={<Link to={`/visit/view/${visit.id}`} className="btn btn-primary"><L>View Encounter</L></Link>}>
                            <div className="row">
                            {visit.wounds.map((obj,idx) => (<div key={idx} className="col-md-3"><Wound2 item={obj} /></div>))}
                            </div>
                        </Card>)}
                    </div>}
                </>}
            </>
        );
    }
}

export default withParamsAndNavigate(OrderWounds);